/*
 * @Author: xushijie xushijie@yunlizhihui.com
 * @Date: 2023-02-08 15:05:19
 * @LastEditors: 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime: 2023-03-01 14:18:59
 * @FilePath: \vue3-ts-mm\src\utils\onMountedOrActivated.ts
 * @Description:  
 * 
 */
// ==== onMountedOrActivated  hook====
import {nextTick, onMounted, onActivated} from 'vue'

export function onMountedOrActivated(hook?: any) {
    let mounted: any
    onMounted(() => {
        hook()
        nextTick(() => {
            mounted = true
        })
    })
    onActivated(() => {
        if (mounted) {
            hook()
        }
    })
}